import Entity from '../entity'

export default class Ratio extends Entity<number>{
    year: number;
    concept_id: number;
    vehicle_type_id: number;
    ratio: number;
}


